import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const data = [
  { name: "Jan", sales: 400 },
  { name: "Feb", sales: 300 },
  { name: "Mar", sales: 500 },
  { name: "Apr", sales: 200 },
  { name: "May", sales: 600 },
];

const Dashboard = () => {
  return (
    <div className="px-5 pt-6 pb-2.5">
      {/* Greeting */}
      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="text-xl font-bold text-white">Hello</h1>
          <p className="text-white text-md mt-1">
            Welcome back!
            <p className="text-sm text-gray-300 mt-1">
              {" "}
              Here's what's happening with your business today.
            </p>
          </p>
        </div>
      </div>

      {/* Summary Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        <div className="bg-white rounded-xl p-4 shadow-md">
          <h2 className="text-gray-500 text-sm mb-1">Total Sales</h2>
          <p className="text-2xl font-semibold text-gray-800">₹1.2L</p>
        </div>
        <div className="bg-white rounded-xl p-4 shadow-md">
          <h2 className="text-gray-500 text-sm mb-1">Active Users</h2>
          <p className="text-2xl font-semibold text-gray-800">856</p>
        </div>
        <div className="bg-white rounded-xl p-4 shadow-md">
          <h2 className="text-gray-500 text-sm mb-1">Revenue</h2>
          <p className="text-2xl font-semibold text-gray-800">₹65K</p>
        </div>
        <div className="bg-white rounded-xl p-4 shadow-md">
          <h2 className="text-gray-500 text-sm mb-1">New Customers</h2>
          <p className="text-2xl font-semibold text-gray-800">37</p>
        </div>
      </div>

      {/* Chart Card */}
      <div className="bg-white rounded-xl p-6 shadow-md mb-6">
        <h2 className="text-lg font-semibold text-gray-800 mb-4">
          Monthly Sales Overview
        </h2>
        <div className="w-full h-64">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data}>
              <XAxis dataKey="name" stroke="#888888" />
              <YAxis stroke="#888888" />
              <Tooltip />
              <Bar dataKey="sales" fill="#405189" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>

      {/* Placeholder for more components */}
      <div className="bg-white rounded-xl p-6 shadow-md">
        <h2 className="text-lg font-semibold text-gray-800 mb-2">
          Recent Activities
        </h2>
        <ul className="text-sm text-gray-600 space-y-1">
          <li>• Order #12345 confirmed</li>
          <li>• Payment received from John Doe</li>
          <li>• New user registered: alice@example.com</li>
        </ul>
      </div>
    </div>
  );
};

export default Dashboard;
